// src/app/components/sidemenu/sidemenu.component.ts
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { TegelModule } from '@scania/tegel-angular-17';
import { RolesService } from '../../services/roles.service';

@Component({
  selector: 'app-sidemenu',
  standalone: true,
  imports: [CommonModule, RouterLink, TegelModule],
  templateUrl: './sidemenu.component.html',
  styleUrl: './sidemenu.component.css',
})
export class SidemenuComponent {
  private readonly roles = inject(RolesService);
  private readonly router = inject(Router);
  readonly isAdmUPS$ = this.roles.hasRole$('AdmUPS');

  isActive(path: string): boolean {
    return this.router.url === path;
  }

  onSubRoute(path: string): boolean {
    return this.router.url.startsWith(path);
  }
}
